import React from "react"

const AuthorAvatar = ({ author }) => {
  const authorName = author
    .replace(/(\s)/g, "-")
    .replace(/([()])/g, "")
    .toLowerCase()

  return <span className={`author-avatar author-avatar--${authorName}`}></span>
}

export default AuthorAvatar
